import { render } from "./PerformanceByCategoryGraphWidget.vue?vue&type=template&id=4eb1b180&scoped=true"
import script from "./PerformanceByCategoryGraphWidget.vue?vue&type=script&lang=js"
export * from "./PerformanceByCategoryGraphWidget.vue?vue&type=script&lang=js"

import "./PerformanceByCategoryGraphWidget.vue?vue&type=style&index=0&id=4eb1b180&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb1b180"]])

export default __exports__